import VueRouter from 'vue-router'
import Vue from 'vue'
// import { v4 as uuidv4 } from 'uuid'
import { set, get, clear } from '../utils/token'
import { post } from '../utils/request'
import { Toast } from 'vant'
import dd from 'DD'
// import Cookies from 'js-cookie'
// import { getUser } from '../utils/ddUser'
import { shareDD2 } from '../utils/utils'
import NoValidationRouter from './noValidation'
import ActiveRouter from './activity'
import groupsRouter from './groups'
import { getExerlandRouter } from './exerland'
import getQuestionnaire from './questionnaire'
import getPrizeInfo from './PrizeInfo'
import store from '../store'
import { getUserPower } from '../utils/power'
// import { routerAuth } from '../router/test'
import { getUserToken } from '../api/api'
import getAccessToken from '../api/getAccessToken'
Vue.use(Toast)

/* eslint-disable-next-line */
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () =>
      import('../views/Home.vue'),
    redirect: '/exerland'
  },
  {
    path: '/battle',
    name: 'Battle',
    meta: {
      title: '战役看板'
    },
    component: () =>
      import('../views/battle/index.vue')
  },
  {
    path: '/calendar',
    name: 'Calendar',
    meta: {
      title: '课程日历'
    },
    component: () =>
      import('../views/calendar/index.vue')
  },
  {
    path: '/login',
    name: 'ExerlandLogin',
    meta: {
      title: '登录'
    },
    component: () =>
      import('../views/exerland/Login.vue')
  },
  {
    path: '/annualDetails',
    name: 'AnnualDetails',
    meta: {
      title: '年度报告'
    },
    component: () =>
      import('../views/annualDetails/index.vue')
  },
  ...NoValidationRouter,
  ...ActiveRouter,
  ...getQuestionnaire,
  ...getPrizeInfo,
  ...groupsRouter
  // {
  //   path: '*',
  //   name: '404',
  //   component: () => import('../views/noValidation/404.vue')
  // }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// const judgeForbbiden = async () => {
//   const user = get('user')
//   const result = await post({
//     url: '/user/userStatus',
//     data: {
//       userId: user.id
//     }
//   })
//   const {
//     data: {
//       code,
//       detail: {
//         isForbidden
//       }
//     }
//   } = result
//   if (!Object.is(code, 200)) {
//     return false
//   }
//   user.isForbidden = isForbidden
//   set('user', user)
//   return isForbidden
// }

const loginProcess = async (to) => {
  let name = to.name
  const user = get('user') ? get('user') : null
  if (!user) {
    name = 'ExerlandLogin'
    if (dd.env.platform !== 'notInDingTalk') {
      name = await judgeDDUser(to)
    }
    if (Object.is(window.location.host, 'localhost:8080') || Object.is(window.location.host, '10.170.108.62:8080')) {
      name = await judgeDDUser(to)
    }
  }
  return name
}

// const judgeUserDetails = async (to) => {
//   const user = get('user')
//   if (!user) {
//     return 'ExerlandLogin'
//   }
//   if (to.path.indexOf('/create') !== -1) {
//     try {
//       const isForbidden = await judgeForbbiden()
//       if (isForbidden) {
//         Toast.fail('你已经被禁言,请联系管理员!')
//         return false
//       }
//     } catch (err) {
//       // alert(JSON.stringify(err))
//     }
//   }
//   return to.name
// }
const judgeDDUser = async (to) => {
  let mobile = ''
  let toastLoading = null
  toastLoading = Toast.loading({
    message: '加载中...',
    duration: 0, // 持续展示 toast
    forbidClick: true
  })
  const DDcode = await getAccessToken()
  const res = await getUserToken({ code: DDcode })
  if (res.code === 200) {
    set('X-Auth', res.token)
    set('mobile', res.mobile)
    mobile = res.mobile
  }
  const _userInfo = await post({
    url: '/user/mobileDingLogin',
    data: {
      phoneNumber: mobile
    }
  })
  try {
    const {
      data: {
        detail,
        message
      }
    } = _userInfo
    if (detail.id) {
      set('user', detail)
      set('mobile', detail.phoneNumber)
    } else {
      Toast.fail(message)
      toastLoading.clear()
      return Promise.resolve('ExerlandLogin')
    }
    /* esline-disable-next-line */
  } catch (err) {
    toastLoading.clear()
    return Promise.resolve('ExerlandLogin')
  }
  await getUserPower()
  toastLoading.clear()
  return Promise.resolve(to.name)
}

const judgeExerlandLogin = async (to, next) => {
  // console.log('to', to)
  let name = to.name
  if (to.path.indexOf('/login') === -1) {
    name = await loginProcess(to)
    // debugger
    // name = await judgeUserDetails(to)
    // debugger
  }
  const routers = getExerlandRouter(store.getters['router/getRouter'])
  if (router.options.routes.length === routes.length) { // 权限路由
    router.addRoutes(routers)
    router.options.routes = [
      ...router.options.routes,
      ...routers
    ]
    next({ ...to, replace: true })
  } else {
    if (Object.is(name, to.name)) {
      next()
    } else {
      next({
        name
      })
    }
  }
}
const judgeBattleLogin = async (to, next) => {
  let name = to.name
  if (to.path.indexOf('/login') === -1) {
    name = await loginProcess(to)
  }
  if (Object.is(name, to.name)) {
    next()
  } else {
    next({
      name
    })
  }
}

// router.$addRoutes = (params) => {
//   router.matcher = new Router({ mode: 'history' }).matcher
//   router.addRouters(params)
// }

router.beforeEach((to, from, next) => {
  if (dd.env.platform !== 'notInDingTalk' && !get('X-Auth')) {
    clear()
  }
  // if (to.path === '/exerland') {
  //   clear() // 清除cookies, 和 localstore
  // }
  shareSetTitle(to)
  if (to.path.indexOf('/exerland') !== -1) {
    judgeExerlandLogin(to, next)
  } else if (to.path.indexOf('/battle') !== -1 || to.path.indexOf('/calendar') !== -1 || to.path.indexOf('/annualDetails') !== -1) {
    if (dd.env.platform !== 'notInDingTalk' && (from.to === '/' || from.to === undefined)) { // 钉钉环境下，切是从根目录路径下
      clear() // 清除cookies, 和 localstore
    } else {

    }
    judgeBattleLogin(to, next)
  } else if (to.path.indexOf('/noValidation') !== -1) {
    next()
  } else {
    next()
  }
})
function shareSetTitle (to) {
  let title = '星圈'
  if (to.meta && to.meta.title) {
    title = to.meta.title
  }
  // let image = null
  if (dd.env.platform !== 'notInDingTalk') {
    dd.biz.navigation.setRight({
      show: true, // 控制按钮显示， true 显示， false 隐藏， 默认true
      control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
      text: '分享', // 控制显示文本，空字符串表示显示默认文本
      onSuccess: function (result) {
        shareDD2({
          title: '星圈 — 复星人自己的朋友圈',
          content: '这是一个可以发吐槽、看八卦、找乐子的地方...',
          url: `dingtalk://dingtalkclient/action/openapp?corpid=ding7a05491d2e914134&container_type=work_platform&app_id=0_941215726&redirect_type=jump&redirect_url=https://ui-circle.fosun.com${to.fullPath}`,
          img: 'https://exerlalnd.oss-cn-shanghai.aliyuncs.com/exerland-wechat/resource/image/logo 2220816095538.png'
        })
      }
    })
    dd.ready(() => {
      dd.biz.navigation.setTitle({
        title: title
      })
    })
  }
  document.title = title
}

export function shareDDTtitle ({ title = '日历管理', content = '复星人最【火热】的专属互动、学习、分享社区', url = '', img = 'https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E5%90%90%E6%A7%BD%E5%A4%A7%E4%BC%9A%E5%88%86%E4%BA%AB%E5%9B%BE%E6%A0%87.png' }) {
  if (dd.env.platform !== 'notInDingTalk') {
    dd.biz.util.share({
      type: 0, // 分享类型，0:全部组件 默认；1:只能分享到钉钉；2:不能分享，只有刷新按钮
      url,
      title,
      content,
      image: img
    })
  }
}
window.shareSetTitle = shareDDTtitle

export default router
